export enum UseControlFlag {
    SingleUse = 'SingleUse',
    LimitedMultiUse = 'LimitedMultiUse',
    UnlimitedMultiUse = 'UnlimitedMultiUse'
}